import apiClient from "@/api/client";
import type { OrderMailLog } from "../types";

export const orderMailLogApi = {
  list: (orderId: string) =>
    apiClient
      .get<{ data: OrderMailLog[] }>(`/orders/${orderId}/mail-log/`)
      .then((r) => r.data.data),

  retry: (orderId: string, logId: string) =>
    apiClient
      .post<{ data: OrderMailLog }>(`/orders/${orderId}/mail-log/${logId}/retry/`)
      .then((r) => r.data.data),

  /** First-time send for orders approved before notifications existed. */
  send: (orderId: string) =>
    apiClient
      .post<{ data: OrderMailLog }>(`/orders/${orderId}/mail-log/send/`)
      .then((r) => r.data.data),
};
